export function formatPhone(phone: string): string {
  return `${phone.substr(0, 2)}-${phone.substr(2, 3)}-${phone.substr(5, 3)}`;
}

export function calculateVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
